export default "__VITE_ASSET__JNA2gUmk__"